import WaybillsTableColumnCarNumber from './index.vue'
export default WaybillsTableColumnCarNumber